<div class="modal-header" style="max-width:500px;">
  <h4 class="modal-title" style="color: red;" *ngIf="notify.status == 'Failure'">{{notify.status}}</h4>
  <h4 class="modal-title" *ngIf="notify.status != 'Failure'">{{notify.status}}</h4>
</div>
<div class="modal-body"  style="max-width:500px;">
  <p style="color: red;" *ngIf="notify.status == 'Failure'">{{notify.message}}!</p>
  <p *ngIf="notify.status != 'Failure'">{{notify.message}}!</p>
</div>